module.exports = __webpack_public_path__ + "static/media/queen.3b1853dd.svg";